import { accessRole } from "../../../../helpers/access_role"

import React, { Fragment, useState, useRef, useEffect } from "react"
import classnames from "classnames"
import apiResponse from "../../../../services/apiResponse"
import { Link } from "react-router-dom"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Input,
    Label,
    Modal,ModalBody,ModalFooter, ModalHeader,
    Spinner
} from "reactstrap"

import IndexBloc from "./Blocs/IndexBloc"

import Select from "react-select"
import CustomSelect from "../../../../helpers/ui/CustomSelect"
import moment from "moment"

import TablePPIComponent from './Components/TablePPIComponent'
import TablePPIArvComponent from './Components/TablePPIArvComponent'
import TableRankPromotionComponent from './Components/TableRankPromotionComponent'
import TableGradePromotionComponent from './Components/TableGradePromotionComponent'
import TablePerjadinComponent from './Components/TablePerjadinComponent'
import TablePerjadinCancelComponent from './Components/TablePerjadinCancelComponent'
import TableCancelPresensiComponent from './Components/TableCancelPresensiComponent'

const createMonthOptions = () => {
    var months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];

    return months.map(function(month, i) {
        var newObj = {};
        newObj["label"] = month;
        newObj["value"] = ++i;

        return newObj;
    });
}

const IndexView = (props) => {
  
    let indexBloc = new IndexBloc();

    const [activeTab, setactiveTab] = useState("1")    
    const ppiRef = useRef(); 
    const ppiArvRef = useRef(); 
    const rankRef = useRef(); 
    const gradeRef = useRef(); 
    const perjadinRef = useRef(); 
    const perjadinCancelRef = useRef(); 
    const presensiRef = useRef(); 

    // Select
    const [optionMonths, setOptionMonth] = useState(createMonthOptions());

    const [selectedMonth, setSelectedMonth] = useState(moment().format('M'))
    const [year, setYear] = useState(new Date().getFullYear())
    
    useEffect( () => {
       console.log('mount')

        return () => {
            console.log('unmount');
        }
    }, [])

    let additionalFilter = {
        month: selectedMonth || "",
        year: year || "",
    };

    const reloadPPIRef = () => ppiRef.current.setTokenAPI()
    const reloadPPIArvRef = () => ppiArvRef.current.setTokenAPI()
    const reloadRankRef = () => rankRef.current.setTokenAPI()
    const reloadGradeRef = () => gradeRef.current.setTokenAPI()
    const reloadPerjadinRef = () => perjadinRef.current.setTokenAPI()
    const reloadPerjadinCancelRef = () => perjadinCancelRef.current.setTokenAPI()
    const reloadPresensiRef = () => presensiRef.current.setTokenAPI()

    function handleButtonSearch() {
      reloadPPIRef()
      reloadPPIArvRef()
      reloadRankRef()
      reloadGradeRef()
      reloadPerjadinRef()
      reloadPerjadinCancelRef()
      reloadPresensiRef()
    }

    function handleButtonReset() {
      setSelectedMonth(null)

      setTimeout(function() {
        reloadPPIRef()
        reloadPPIArvRef()
        reloadRankRef()
        reloadGradeRef()
        reloadPerjadinRef()
        reloadPerjadinCancelRef()
        reloadPresensiRef()
      }, 100);
    }
    
    function toggle(tab) {
        if (activeTab !== tab) {
            setactiveTab(tab)
        }
    }

    return (
        <Fragment>
            <Container fluid>
                <Row>

                    <Col xs="12">
                        <Card>
                            <CardBody>
                                {/* <div className="float-end">
                                {
                                    (accessRole('create')) ?
                                        <Button 
                                          color="success" 
                                          onClick={() => handleButtonExport()}
                                        >Export</Button>
                                    : null
                                }
                                </div> */}
                                <CardTitle>Data Perubahan</CardTitle>
                                {/* <CardSubtitle className="mb-3">
                                    Flexible Report
                                </CardSubtitle> */}
                                <hr />

                                <Row className="mb-3">
                                    <label
                                        htmlFor="gender"
                                        className="col-md-2 col-form-label"
                                    >
                                    Bulan
                                    </label>
                                    <Col md="2">
                                        <Select
                                            value={optionMonths?.filter(option => 
                                              option.value == selectedMonth)}
                                            onChange={(v) => setSelectedMonth(v.value)}
                                            required="required"
                                            options={optionMonths}
                                            classNamePrefix="select2-unitx"
                                        />
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <label
                                        htmlFor="gender"
                                        className="col-md-2 col-form-label"
                                    >
                                    Tahun
                                    </label>
                                    <Col md="2">
                                        <Input
                                            type="text"
                                            name="year"
                                            value={year}
                                            onChange={event => setYear(event.target.value)}
                                            disabled={true}
                                        />
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col md="2"></Col>
                                    <Col md="10">
                                        <Button 
                                            color="primary" 
                                            type="button"
                                            onClick={() => {
                                                handleButtonSearch()
                                            }}
                                        >
                                            <i className="uil-search-alt"></i> Cari
                                        </Button>
                                        {/* {' '}
                                        <Button 
                                          color="warning" 
                                          type="button"
                                          onClick={() => {
                                              handleButtonReset()
                                          }}>
                                            <i className="uil-refresh"></i> Reset
                                        </Button> */}
                                    </Col>
                                </Row>


                                <hr />

                                <Nav tabs>
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                                active: activeTab === "1",
                                            })}
                                            onClick={() => {
                                                toggle("1")
                                            }}
                                        >
                                            <span className="d-block d-sm-none"><i className="fas fa-home"></i></span>
                                            <span className="d-none d-sm-block">Data PPI/PPPI</span>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                            active: activeTab === "2",
                                                })}
                                            onClick={() => {
                                                toggle("2")
                                            }}
                                        >
                                            <span className="d-block d-sm-none"><i className="far fa-envelope"></i></span>
                                            <span className="d-none d-sm-block">Data Pangkat/Golongan</span>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                            active: activeTab === "3",
                                                })}
                                            onClick={() => {
                                                toggle("3")
                                            }}
                                        >
                                            <span className="d-block d-sm-none"><i className="far fa-envelope"></i></span>
                                            <span className="d-none d-sm-block">Data Perubahan Kelas Jabatan</span>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                            active: activeTab === "4",
                                                })}
                                            onClick={() => {
                                                toggle("4")
                                            }}
                                        >
                                            <span className="d-block d-sm-none"><i className="far fa-envelope"></i></span>
                                            <span className="d-none d-sm-block">Data Perjalanan Dinas</span>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                            active: activeTab === "5",
                                                })}
                                            onClick={() => {
                                                toggle("5")
                                            }}
                                        >
                                            <span className="d-block d-sm-none"><i className="far fa-envelope"></i></span>
                                            <span className="d-none d-sm-block">Data Presensi Dibatalkan</span>
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                                <TabContent activeTab={activeTab} className="p-3 text-muted">
                                    <TabPane tabId="1">
                                        <TablePPIComponent ref={ppiRef} additionalFilter={additionalFilter}/>
                                        <hr />
                                        <TablePPIArvComponent ref={ppiArvRef} additionalFilter={additionalFilter}/>
                                    </TabPane>
                                    <TabPane tabId="2">
                                        <TableRankPromotionComponent ref={rankRef} additionalFilter={additionalFilter}/>
                                    </TabPane>
                                    <TabPane tabId="3">
                                        <TableGradePromotionComponent ref={gradeRef} additionalFilter={additionalFilter}/>
                                    </TabPane>
                                    <TabPane tabId="4">
                                        <TablePerjadinComponent ref={perjadinRef} additionalFilter={additionalFilter}/>
                                        <hr />
                                        <TablePerjadinCancelComponent ref={perjadinCancelRef} additionalFilter={additionalFilter}/>
                                    </TabPane>
                                    <TabPane tabId="5">
                                        <TableCancelPresensiComponent ref={presensiRef} additionalFilter={additionalFilter}/>
                                    </TabPane>
                                </TabContent>
                                
                                <hr />
                                <div>
                                    <Button color="success"><i className="uil-check"></i> Verifikasi</Button>
                                </div>
                                
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>

        </Fragment>
    )
}

export default IndexView